import { render, staticRenderFns } from "./EnquiryTemplates.vue?vue&type=template&id=2507217c&"
import script from "./EnquiryTemplates.vue?vue&type=script&lang=js&"
export * from "./EnquiryTemplates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPage,QTable,QInput,QIcon,QTd} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPage,QTable,QInput,QIcon,QTd})
